import { MatchEditPage } from "@/features/match/pages/MatchEdit";

const MatchEdit = () => {
  return <MatchEditPage />;
};

export default MatchEdit;
